import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { CrewEvaluation, CrewEvaluationCategory } from '../../../types';

interface EvaluationCategoriesSectionProps {
  categoryFields: (CrewEvaluationCategory & { id: string })[];
  watchedCategories: CrewEvaluationCategory[];
  updateItemRating: (categoryIndex: number, itemIndex: number, rating: number) => void;
  register: UseFormRegister<CrewEvaluation>;
}

const EvaluationCategoriesSection: React.FC<EvaluationCategoriesSectionProps> = ({
  categoryFields,
  watchedCategories,
  updateItemRating,
  register
}) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Evaluation Criteria</h3>
      {categoryFields.map((category, categoryIndex) => (
        <div key={category.id} className="mb-6 border border-gray-200 rounded-lg p-4">
          <div className="flex items-center justify-between mb-4">
            <h4 className="text-md font-medium text-gray-800">{category.name}</h4>
            <div className="flex items-center">
              <span className="text-sm text-gray-600 mr-2">Category Average:</span>
              <div className="w-12 h-8 bg-blue-100 rounded flex items-center justify-center">
                <span className="text-sm font-medium text-blue-800">
                  {watchedCategories?.[categoryIndex]?.categoryRating || 0}
                </span>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            {category.items.map((item, itemIndex) => (
              <div key={item.id} className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {item.criteriaName}
                  </label>
                </div>
                
                <div>
                  <select
                    value={watchedCategories?.[categoryIndex]?.items[itemIndex]?.rating || 0}
                    onChange={(e) => updateItemRating(categoryIndex, itemIndex, parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value={0}>0 - Not Evaluated</option>
                    <option value={1}>1 - Poor</option>
                    <option value={2}>2 - Below Average</option>
                    <option value={3}>3 - Average</option>
                    <option value={4}>4 - Above Average</option>
                    <option value={5}>5 - Excellent</option>
                  </select>
                </div>
                
                <div>
                  <input
                    type="text"
                    placeholder="Comments (optional)"
                    {...register(`categories.${categoryIndex}.items.${itemIndex}.comments` as const)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EvaluationCategoriesSection;
